<template>
  <PgButtonActionsContext
    class="pg-page-query"
    :class="{ 'pg-page-query--center': !!isCenter }"
    :actions="actions"
  >
    <PgButtonGroup
      class="pg-page-query__button"
      :list="topButtons"
      :type="'text'"
      :round="false"
      :compileData="compileData"
    >
      <template #right>
        <slot></slot>
      </template>
    </PgButtonGroup>
    <PgTopRemind
      class="pg-page-query__remind"
      :errors="topErrors"
      :success="topSuccess"
    ></PgTopRemind>
    <div
      class="pg-page-query__shortcut"
      v-if="
        frontMenus?.length > 0 ||
        otherMenus?.length > 0 ||
        customMenus?.length > 0 ||
        shortcutForm?.items?.length > 0
      "
    >
      <PgCriteriaMenus
        class="pg-page-query__shortcut-left"
        :frontMenus="frontMenus"
        :otherMenus="otherMenus"
        :customMenus="customMenus"
        @seach="criteriaMenu"
      ></PgCriteriaMenus>
      <PgForm
        class="pg-page-query__shortcut-right"
        v-if="!!shortcutForm"
        :formItems="shortcutForm"
        :model="shortcutData"
      ></PgForm>
    </div>
    <div class="pg-page-query__groups" v-if="groupsForm?.items?.length > 0">
      <span class="pg-page-query__groups-title">合并：</span>
      <PgForm :formItems="groupsForm" :model="groups"></PgForm>
    </div>
    <PgQueryTag :queryForm="queryForm" :queryData="queryData" @close="closeProperty"></PgQueryTag>
    <PgTable
      class="pg-page-query-table"
      ref="tableRef"
      height="100%"
      autoResize
      :loading="loading"
      :column="columns"
      :sortConfig="{ defaultSort: tableSortings }"
      :onlyShowFields="onlyShowFields"
      :buttonRow="rowMenuLead"
      :isSelection="isSelection"
      :seqIndex="seqIndex"
      :rowConfig="rowConfig"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxAll"
      @sort-change="sortChangeFn"
      @column-custom="columnCustom"
    ></PgTable>
    <div class="pg-page-query__page">
      <div class="pg-page-query__page-left">
        <span class="pg-page-query__page-left-selection" v-if="isSelection"
          >已选择{{ selections.length }}项</span
        >
        <span>耗时: {{ queryTime }}ms</span>
      </div>
      <PgPagination
        class="pg-page-query__page-right"
        :total="totalCount"
        :pageSize="page.pageSize"
        :pageSizes="pageSizes"
        :current-page="page.pageNo"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
  </PgButtonActionsContext>
</template>
<script setup>
import { PgTable } from '../../table/index'
import { PgPagination } from '../../pagination/index'
import {
  useButtonPage,
  useTopErrors,
  useBeforValueActionsProvide,
  useTableSort,
} from '../../../hooks/index'
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { PgButtonGroup } from '../../button-group/index'
import { PgTopRemind } from '../../top-remind/index'
import { PgForm } from '../../form/index'
import PgQueryTag from './query-tag.vue'
import PgCriteriaMenus from './criteria-menus.vue'
import { post } from '../../../utils/index'
import { shallowRef, reactive, ref, computed, onMounted, onDeactivated } from 'vue'
import { useCriteriaGroups } from '../hook/use-criteria-groups'
import { useCriteriaQuery } from '../hook/use-criteria-query'
import { useGetCriteriaMenu } from '../hook/use-get-criteria-menus'
import { useInitParameters } from '../hook/use-init-parameters'

const props = defineProps({
  rowConfig: Object,
  columnTableCode: String,
  columnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  column: [Array, Object],
  pageSize: {
    type: Number,
    default: 10,
  },
  pageSizes: Array,
  dataUrl: String,
  dataParameters: Object,
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  criteriaCode: String,
  menus: Array,
  topMenuLead: {
    type: String,
    default: 'TOP',
  },
  rowMenuLead: {
    type: String,
    default: 'ROW',
  },
  beforActions: Object,
  // 表单或表格数据变化完成后回调
  afterCallback: Function,
  buttonActions: Object,
  selectionMenuUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/menu/options',
  },
  getCriteriaMenuUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/menu/getOfEdit',
  },
  //初始是否请求数据
  initialLoad: {
    type: Boolean,
    default: true,
  },
  isSelection: {
    type: Boolean,
    default: true,
  },
  parametersStorageSuffix: [String, Number],
  // 为true时可将快捷查询居中对齐
  isCenter: Boolean,
})

const { getButtonByKey } = useButtonPage(props.menus)
const topButtons = getButtonByKey(props.topMenuLead)

const { groups, groupsForm, setGroupsForm, onlyShowFields } = useCriteriaGroups()
const {
  queryData,
  updateQueryData,
  queryForm,
  shortcutForm,
  shortcutData,
  setQueryForm,
  setDefaultQuery,
  updateQueryAndShortcutData,
} = useCriteriaQuery()

const {
  getCriteria,
  getMenu,
  setParametersBySessionStorage,
  getPageSizeLocalStorage,
  setPageSizeLocalStorage,
} = useInitParameters({
  criteriaUrl: props.criteriaUrl,
  criteriaCode: props.criteriaCode,
  getCriteriaMenuUrl: props.getCriteriaMenuUrl,
  parametersStorageSuffix: props.parametersStorageSuffix,
})

const page = ref({
  pageNo: 1,
  pageSize: getPageSizeLocalStorage() ?? props.pageSize,
})

const seqIndex = computed(() => (page.value.pageNo - 1) * page.value.pageSize)

const { sortings, tableSortings, sortChange, columns, getcolumns, reloadColumn } = useTableSort({
  columnUrl: props.columnUrl,
  columnTableCode: props.columnTableCode,
  column: props.column,
  parametersStorageSuffix: props.parametersStorageSuffix,
})
const seachParameters = computed(() => {
  const parameters = {
    ...props.dataParameters?.parameters,
    ...queryData.value,
    ...shortcutData.value,
  }
  const keys = Object.keys(groups.value)
  for (const key of keys) {
    if (groups.value[key] !== false) {
      parameters[key] = groups.value[key]
    }
  }
  return {
    criteriaCode: props.criteriaCode,
    tableCode: props.columnTableCode,
    ...page.value,
    ...props.dataParameters,
    parameters,
    sortings: sortings.value,
  }
})

//复选框
const selections = shallowRef([])
const selectionsMap = new Map()
const setSelections = (key, records) => {
  selectionsMap.set(key, records)
  selections.value = [].concat(...selectionsMap.values())
}
const clearSelections = () => {
  selectionsMap.clear()
  selections.value = []
}
const checkboxChange = ({ records }) => {
  setSelections(page.value.pageNo, records)
}
const checkboxAll = ({ records }) => {
  setSelections(page.value.pageNo, records)
}

const tableRef = ref(null)
const data = shallowRef([])
const totalCount = ref(null)
const loading = ref(false)
const queryTime = ref(0)
const getData = async () => {
  loading.value = true
  const startTime = Date.now()
  const [res] = await post(props.dataUrl, seachParameters.value).catch(() => {
    loading.value = false
    queryTime.value = Date.now() - startTime
  })
  loading.value = false
  queryTime.value = Date.now() - startTime
  if (res) {
    setParametersBySessionStorage(seachParameters.value.parameters)
    data.value = res.data ?? []
    totalCount.value = res.totalCount ?? 0

    tableRef.value
      ?.loadDataAsync?.(() => res)
      .then(() => {
        const pageSelections = selectionsMap.get(page.value.pageNo)
        if (pageSelections?.length > 0) {
          setTimeout(() => {
            tableRef.value?.setCheckboxRow?.(pageSelections, true)
          })
        }
      })
  } else {
    data.value = []
    totalCount.value = 0
  }
}
//解决由于数据量大时并且滚动之后导致表格数据都被vue监听在缓存时占用空间大
// onDeactivated(() => {
//   data.value = JSON.parse(JSON.stringify(data.value))
//   tableRef.value?.clearOb?.(data.value)
// })
// onActivated(() => {
//   if (selectionsMap.get(page.value.pageNo)?.length > 0) {
//     tableRef.value?.setCheckboxRow?.(selectionsMap.get(page.value.pageNo), true)
//   }
// })
onDeactivated(() => {
  tableRef.value?.scrollTo(0, 0)
})

const sizeChange = (val) => {
  page.value.pageSize = val
  setPageSizeLocalStorage(val)
  page.value.pageNo = 1
  clearSelections()
  getData()
}
const currentChange = (val) => {
  page.value.pageNo = val
  getData()
}
const reload = () => {
  page.value.pageNo = 1
  clearSelections()
  getData()
}

//更新查询侧滑查询条件并且刷新表格
const closeProperty = (property, val = null) => {
  updateQueryData(property, val)
  reload()
}

const sortChangeFn = ({ sortList }) => {
  sortChange(sortList)
  reload()
}

const columnCustom = async () => {
  await reloadColumn()
  reload()
}

const { initGetMenus, getCustomMenus, frontMenus, otherMenus, customMenus } = useGetCriteriaMenu({
  selectionMenuUrl: props.selectionMenuUrl,
})

//选择保存的查询条件时
const criteriaMenu = async (id) => {
  const menuParameter = await getMenu(id)
  updateQueryAndShortcutData(menuParameter)
  reload()
}

onMounted(() => {
  Promise.all([getCriteria(), getcolumns()]).then(([[res, defaultParameter]]) => {
    setQueryForm(res, reload)
    setGroupsForm(res, reload)
    if (defaultParameter) {
      updateQueryAndShortcutData(defaultParameter)
    } else {
      setDefaultQuery()
    }

    initGetMenus(queryForm.value.id)
    if (props.initialLoad) {
      getData()
    }
  })
})

const compileData = reactive({
  data,
  parameters: seachParameters,
  selections,
  queryForm,
  queryData,
  shortcutData,
})

const { topErrors, updateErrors, topSuccess, updateSuccess } = useTopErrors()

const actions = {
  ...props.buttonActions,
  updateTopErrors: ({ errors }) => updateErrors(errors),
  updateTopSuccess: ({ data }) => updateSuccess(data),
  updateQueryData: ({ data }) => {
    //data不存在时表示时保存自定义查询条件，刷新自定义查询条件展示
    if (!data) {
      getCustomMenus(queryForm.value.id)
    } else {
      closeProperty(null, data)
    }
  },
  reload,
}

// 修改字段值前的勾子
const beforActions = {
  ...props.beforActions,
}
useBeforValueActionsProvide({
  beforActions,
  formReactive: {},
  actions,
  afterCallback: props.afterCallback,
})
</script>
<style lang="scss">
@import '../style/page-query.scss';
</style>
